export function ISMOBILE() {
  // 判断尺寸
  if ( window.innerWidth <= 1024 && window.innerWidth < window.innerHeight) {
    // 移动端
    return true
  } else {
    // pc端
    return false
  }
}

/**
 * @description 文字转语音方法
 * @public
 * @param { text, rate, lang, volume, pitch } object
 * @param  text 要合成的文字内容，字符串
 * @param  rate 读取文字的语速 0.1~10  正常1
 * @param  lang 读取文字时的语言
 * @param  volume  读取时声音的音量 0~1  正常1
 * @param  pitch  读取时声音的音高 0~2  正常1
 * @returns SpeechSynthesisUtterance
 */
export const speak = ({
	text,
	speechRate,
	lang,
	volume,
	pitch
}, endEvent, startEvent,callBack) => {
	if (!window.SpeechSynthesisUtterance) {
		alert('当前浏览器不支持文字转语音服务')
    // this.$message.error('当前浏览器不支持文字转语音服务')
		// uni.showToast({
		// 	title: '当前浏览器不支持文字转语音服务',
		// 	icon: 'none'
		// })
		callBack&&callBack()
		return;
	}

	if (!text) {
		return;
	}
	// 去掉转义字符
	text = text.replace(/[\'\"\\\/\b\f\n\r\t]/g, '');
	// 去掉特殊字符  
	text = text.replace(/[\@\#\$\%\^\&\*\{\}\:\"\L\<\>\?]/);

	const speechUtterance = new SpeechSynthesisUtterance();
	speechUtterance.text = text;
	speechUtterance.rate = speechRate || 1;
	speechUtterance.lang = lang || 'zh-CN';
	speechUtterance.volume = volume || 1;
	speechUtterance.pitch = pitch || 1;
	speechUtterance.onend = function() {
		endEvent && endEvent();
	};
	speechUtterance.onstart = function() {
		startEvent && startEvent();
	};
  window.speechSynthesis.cancel()
	window.speechSynthesis.speak(speechUtterance);

	return speechUtterance;
}